import { Service } from '@angular/core';
import { environment } from '@environments/environment';
import { HttpServiceBase } from './http-service-base';

/** HTTP access to the client API (`clientApiUrl`). Used by door data services. */
@Service()
export class ClientHttpService extends HttpServiceBase {
  protected readonly baseUrl = environment?.clientApiUrl ?? '';
}
